"use client";
import { createContext } from "../../utils/create-context.js";
//#region src/components/field/use-field-context.ts
var [FieldProvider, useFieldContext] = createContext({
	name: "FieldContext",
	hookName: "useFieldContext",
	providerName: "<FieldProvider />",
	strict: false
});
//#endregion
export { FieldProvider, useFieldContext };
